import Loader from '../loader/loader.js'
import MessageBoxManager from '../messageBox/messageBoxManager.js'
import "./shippingManager.scss"
import SenderShippingWizard from "./senderShippingWizard.js"
import EventManager from "../eventManager.js"
import Config from '../config.js'

export default class ShippingManager extends EventManager {

  constructor(options) {
    super()

    this.settings = $.extend({}, {
      defaultZoom: 15,
      apiKey: Config.mapsApiKey,
      animationQueue: null
    }, options);

    this.$container = $('#shipping_block');
    this.$container.find('> .sender > .content').hide();

    this.$actionsBar = $('<div/>', { class: 'actions-bar' })
      .insertAfter(this.$container);

    this.messageBoxManager = new MessageBoxManager(
      this.$container.closest('.contenu').children('.stacked-rounded-list'),
      {
        method: 'insertAfter',
        extraClasses: 'message-box'
      }
    );
    
    // this.$validationButton = $('<button/>', { class: 'button large validate disabled' })
    //     .html('Valider')
    //     .click(() => {
    //             if (!this.$validationButton.hasClass('disabled')) {
    //                 console.log('Final validation!');
    //             }
    //         })
    //     .appendTo(this.$actionsBar);

    this.currentAddress = null;

    this.loaders = [];
    this.loaderTasks = [];

    this.senderShippingWizards = {};
    this.initLoaders();

  }

  waitReload() {

    this.startLoaders();
    //this.$validationButton.addClass('disabled');
    this.on('unvalidate');

    return this;
  }

  initLoaders() {

    this.$container.find('> .sender > .content').each((index, content) => {
      let senderId = parseInt($(content).parent().attr('data-id'));
      if (this.loaders[senderId] == undefined) {
        this.loaders[senderId] = new Loader($(content));
      }
    });

    return this;

  }

  startLoaders() {

    for (let senderId in this.loaders) {
      this.startLoader(senderId);
    }

    return this;
  }

  stopLoaders() {
    for (let sid in this.loaders) {
      this.stopLoader(sid);
    }

    return this;
  }

  startLoader(id, force) {
    force = force != undefined ? force : false;
    if (!this.loaders[id].isStarted()) {
      let $loaderContainer = this.$container.find('> .sender[data-id=' + id + '] > .content');
      if (force || $loaderContainer.is(':visible')) {
        $loaderContainer.removeClass('loading');
        this.loaderTasks[id] = this.loaders[id].startTask();
      } else {
        $loaderContainer.addClass('loading');
      }
    }

    return this;
  }

  forceLoaderVisibility(id) {
    let $loaderContainer = this.$container.find('> .sender[data-id=' + id + '] > .content');

    if ($loaderContainer.hasClass('loading')) {
      this.startLoader(id, true);
    }
  }

  stopLoader(id) {
    this.loaders[id].stopTask(this.loaderTasks[id]);
    this.$container.find('> .sender[data-id=' + id + '] > .content').removeClass('loading');
    return this;
  }

  updateAddress(address) {

    this.startLoaders();

    this.currentAddress = address;
    for (let senderId in this.senderShippingWizards) {
      this.senderShippingWizards[senderId].updateAddress(address);
    }

    this.updateOffers();

    return this;
  }

  updateOffers() {

    let senderIdsGroups = {
      bb: [],
      marketplace: []
    };

    $.each(this.$container.find('> .sender[data-id] > .content'), (index, content) => {
      let senderId = parseInt($(content).parent().attr('data-id'));
      senderIdsGroups[senderId == 0 ? 'bb' : 'marketplace'].push(senderId);
    });

    for (let groupId in senderIdsGroups) {
      let group = senderIdsGroups[groupId];
      if (group.length > 0) {
        for (let senderId of group) {
          if (!(senderId in this.senderShippingWizards)) {
            this.senderShippingWizards[senderId] = new SenderShippingWizard(
              senderId,
              this.$container.find('> .sender[data-id=' + senderId + ']'),
              { animationQueue: this.settings.animationQueue }
            );

            this.senderShippingWizards[senderId].addListener('select', this.onSelectShippingMode.bind(this));
            this.senderShippingWizards[senderId].addListener('unselect', this.onSelectShippingMode.bind(this));
            this.senderShippingWizards[senderId].addListener('validation_succeed', this.onValidateShippingMode.bind(this));
            this.senderShippingWizards[senderId].addListener('validation_succeed', super.on.bind(this, 'validate_sender'));
            this.senderShippingWizards[senderId].updateAddress(this.currentAddress);
          }
        }

        $.post("core/ajax/ajax_panier.php", {
          action: "livraison",
          id_merchants: group.join(','),
          _format: 'json',
          pays: this.currentAddress.country
        }).done(response => {
          this.messageBoxManager.clearNotifications();
          if (!response || response.infos == undefined || response.senders == undefined || response.ressources == undefined) {
            this.messageBoxManager.notifyUnexpectedError();
            this.stopLoaders();
            return;
          }
          
          if (this.currentAddress.country == 'FRA') {
              $('#progressBar').removeClass('no');
            }
            else {
                $('#progressBar').addClass('no');
            }

          // console.log(`Livraison ${groupId} update : `, response);
          // Check for general purpose messages
          for (let info of response.infos) {
            this.messageBoxManager.notify(info.message, { type: info.level });
          }

          for (let senderId in response.senders) {
            this.senderShippingWizards[senderId].configure({ ressources: response.ressources });

            this.senderShippingWizards[senderId].update(response.senders[senderId], {
              loader: this.loaders[senderId],
              birthList: response.birthList
            });
            this.stopLoader(senderId);
          }
        }).fail(() => {
          this.messageBoxManager.notifyUnexpectedError();
          this.stopLoaders();
        });
      }
    }

    this.$container.find('> .sender > .content').hide().parent().removeClass('opened');
    let $firstSender = this.$container.find('> .sender').first();
    let firstSenderId = $firstSender.attr('data-id');

    if (this.senderShippingWizards[firstSenderId]) {
      $firstSender.addClass('opened')
      $firstSender.find('> .content').slideDown({
        start: () => {
          this.forceLoaderVisibility(firstSenderId);
          this.senderShippingWizards[firstSenderId].invalidate();
        }
      });
    }

    //this.$validationButton.addClass('disabled');
    this.on('unvalidate');
  }

  onSelectShippingMode() {
    let [senderWizard, modeWizard, ...args] = [...arguments];
    //this.$validationButton.addClass('disabled');
    this.on('unvalidate');
  }

  onValidateShippingMode() {
    let [senderWizard, ...args] = [...arguments];

    // retrieve list of senders ordered by index
    let wizards = [];
    for (let i in this.senderShippingWizards) {
      wizards.push(this.senderShippingWizards[i]);
    }

    let sortedWizards = wizards.sort((w1, w2) => w1.$container.index() - w2.$container.index());

    let relevantWizards = sortedWizards.filter(w => !w.isValidated);

    if (relevantWizards.length > 0) {
      relevantWizards[0].$container.addClass('opened')
      relevantWizards[0].$content.slideDown({
        start: () => {
          this.forceLoaderVisibility(relevantWizards[0].senderId);
          relevantWizards[0].invalidate();
        }
      })
      this.settings.animationQueue.add($('html, body'), $.fn.animate, {
        get scrollTop() { return relevantWizards[0].$container.offset().top - Config.headerHeightMobile }
      },
        'slow'
      )
    } else {
      this.on('validate');
    }

    return this;
  }
}
